import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStart$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStart extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '89fa74ea37700148a0b9f5eb691256dbcc627abd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e2d650d294a9688f06d800928a4dce629bcc77bd', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fcf96dc0ce5fa3e35103988660838d7927ba3d4c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5zm1 1.5h13v13h-13zM8 14V8a.3.3 0 0 1 .43-.27l6 3a.3.3 0 0 1 0 .54l-6 3A.3.3 0 0 1 8 14", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-start", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-start"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-start":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStart$1);
            }
            break;
    } });
}

const CosmosIconStart = CosmosIconStart$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStart, defineCustomElement };
